/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React  from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';
import { object, func, bool } from 'prop-types';
import { compose } from 'recompose';
import { Container, Grid } from '@material-ui/core';
import { Query } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import { Link } from 'react-router-dom';
import * as app from '../../../../state/ducks/App';
import { GraphqlSimpleProduct } from '../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/GraphqlSimpleProduct';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getUsersProductIdFromWishlist } from '../../../../state/ducks/App/App-Selectors';
import findProductByPartNumbers from '../../../gql/queries/findProductByPartNumbers';
import SiteLoader from '../../../pages/Checkout/containers/CheckoutFloral/Partials/SiteLoader/SiteLoader';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const brandSelectors = app?.ducks?.brand?.selectors;

const styles = (theme) => ({
    simpleProduct4row: {
        flex: '0 0 50%',
        maxWidth: '50%',
        marginBottom: '30px',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
        [theme.breakpoints.up(769)]: {
            flex: '0 0 25%',
            maxWidth: '25%',
        },
    },
    productRow: {
        boxSizing: 'border-box',
        marginRight: '-10px',
        marginLeft: '-10px',
        width: 'auto',
    },
    fullWidthProductContainer: {
        width: '100%',
        minHeight: '600px',
    },
    warapperBox: {
        paddingTop: '1rem',
    },
    resultWrapper: {
        paddingTop: '1rem',
    },
    favButton: {
        backgroundColor: '#b9e529',
        borderColor: '#b9e529',
        marginTop: '5rem !important',
        color: '#000 !important',
        textDecoration: 'none',
        textAlign: 'center',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontWeight: 800,
        fontSize: 'small',

    },
    heading: {
        '& h1': {
            margin: 0,
            fontFamily: theme?.typography?.secondaryFontFamily,
            lineHeight: '38px',
            fontSize: '2.5rem',
            fontWeight: '500',
        },
        marginTop: '30px',
    },
    favText: {
        margin: '6px',
    },
    noProductContainer: {
        margin: '50px',
        textAlign: 'center',
    },

});
const Wishlist = ({
    classes, brand, featureFlags, getWishlist, showLabel,
}) => {
    const getNoProductMsg = () => (
        <>
            <Grid container xs={12}  className={classes.noProductContainer}>
                <Grid xs={12}>No products saved to your favorites</Grid>
                <Grid xs={12} className={classes.favText}><Link to="/" className={classes.favButton} aria-label="start-browsing" aria-labelledby="start-browsing">START BROWSING</Link></Grid>
            </Grid>

        </>
    );
    const FIND_PRODUCT = findProductByPartNumbers(brand.domain, getWishlist);
    const defaultSeoData = {
        page_title: 'Favorites | Plants.com',
        meta_description: '',
        location: { pathname: '/favorites' },
    };
    return (
        <Query query={FIND_PRODUCT}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <SiteLoader />;
                }
                if (error) {
                    mbpLogger.logError({
                        query: FIND_PRODUCT,
                        component: 'Wishlist.js',
                        message: 'Error loading data from Graphql',
                        error,
                    });
                }
                if (data) {
                    return (
                        <>
                            <GraphqlSeoHeadTags seoData={defaultSeoData} />
                            <Container>
                                <Grid xs={12} className={`${classes.heading}`}>
                                    {showLabel && <h1>Favorites</h1>}
                                </Grid>
                                <Grid container>
                                    <Grid className={classes.fullWidthProductContainer}>
                                        <div className={classes.warapperBox}>
                                            <Grid className={classes.productRow}>
                                                <Grid container className={classes.resultWrapper}>
                                                    {
                                                        (data && data?.findProductByPartNumbers.length) ? data?.findProductByPartNumbers.map((product) => (
                                                            <Grid item className={classes.simpleProduct4row}>
                                                                <GraphqlSimpleProduct
                                                                    partNumber={product?.partNumber}
                                                                    name={product?.name}
                                                                    prices={product?.prices}
                                                                    brand={brand}
                                                                    image={product?.image}
                                                                    url={product?.seo?.url}
                                                                    skuPriceRange={product?.skuPriceRange || []}
                                                                    availability={product?.availability || false}
                                                                    breadCrumbArray={product?.breadCrumbArray || []}
                                                                    skipAddons={false}
                                                                    showMovieUpsell={false}
                                                                    featureFlags={featureFlags}
                                                                    isPassportEligible={false}
                                                                />
                                                            </Grid>
                                                        ),

                                                        ) : getNoProductMsg()

                                                    }
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Container>
                        </>
                    );
                }
                return null;
            }}
        </Query>
    );
};
Wishlist.propTypes = {
    brand: object.isRequired,
    featureFlags: object.isRequired,
    classes: object.isRequired,
    getWishlist: func.isRequired,
    showLabel: bool,
};
Wishlist.defaultProps = {
    showLabel: true,
};
const mapStateToProps = (state) => ({
    getWishlist: getUsersProductIdFromWishlist(state),
    featureFlags: getFeatureFlags(state),
    brand: brandSelectors.getBrand(state),
});

const enhance = compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps),
);

export default enhance(Wishlist);
